import { Route, Routes } from 'react-router-dom';
import ComplaintManagementPage from '../pages/ComplaintManagementPage';
import ComplaintSettingsPage from '../pages/ComplaintSettingsPage';
import ShowTablePage from '../pages/ShowTablePage';
import NewQuery from '../pages/NewQuery';
function ComplaintRouter({ pageProps, onPublish, onStepChange, children }) {
  const managementPage = children ?? <ComplaintManagementPage {...pageProps} />;
  // const SettingsPage = children ?? (
  //   <ComplaintSettingsPage
  //     onPublish={onPublish}
  //     onStepChange={onStepChange}
  //     {...pageProps}
  //   />
  // );

  console.log('ComplaintRouter pageProps:', pageProps.rolelist);

  return (
    <Routes>
      <Route path="/" element={managementPage} />
      <Route
        path="/settings/:systemId"
        element={
          <ComplaintSettingsPage
            onPublish={onPublish}
            onStepChange={onStepChange}
            pageProps={pageProps}
           
          />
        }
      />

      <Route path="querymanagement" element={<ShowTablePage />} />
      <Route path="querymanagement/new/:complaintTypeId" element={<NewQuery />} />
      <Route path="querymanagement/:complaintTypeId" element={<ShowTablePage />} />
      <Route path="*" element={managementPage} />
    </Routes>
  );
}

export default ComplaintRouter;
